import { render, staticRenderFns } from "./UpdateBusinessMemberGender.vue?vue&type=template&id=72548b04"
import script from "./UpdateBusinessMemberGender.vue?vue&type=script&lang=js"
export * from "./UpdateBusinessMemberGender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports